import { startOfDay, subWeeks } from 'date-fns';
import type { DateRange } from '@/types/filters';

export type ArchiveWindow = 'recent' | 'all' | 'custom';

export function recentArchiveRange(now = new Date()): DateRange {
  return { from: startOfDay(subWeeks(now, 8)), to: undefined };
}

export function restoreArchiveWindow(
  range: DateRange,
  storedWindow: unknown,
  now = new Date(),
): { archiveWindow: ArchiveWindow; createdAt: DateRange } {
  if (storedWindow === 'all') {
    return {
      archiveWindow: 'all',
      createdAt: { from: undefined, to: undefined },
    };
  }
  if (storedWindow !== 'recent' && (range.from || range.to)) {
    return { archiveWindow: 'custom', createdAt: range };
  }
  return { archiveWindow: 'recent', createdAt: recentArchiveRange(now) };
}

// Clearing a date filter restores the bounded default; all history has its own opt-in.
export function changeArchiveRange(range: DateRange, now = new Date()) {
  return restoreArchiveWindow(range, undefined, now);
}
